import * as Hooks from 'preact/hooks';
import { useDispatch } from 'react-redux';
import { useSelector } from '../redux';
import * as Logging from '../../../store/actions/logging';
import * as Selectors from '../../../store/selectors';

export const useGetCatalogueEntries = () => {
    const dispatch = useDispatch();
    const tenantIdentifier = useSelector(Selectors.Core.tenantIdentifier);
    // TODO: type catalogue entries
    const [catalogueEntries, setCatalogueEntries] = Hooks.useState<Array<any> | null>(null);

    Hooks.useEffect(() => {
        if (!tenantIdentifier) return;

        const setter = async () => {
            switch (tenantIdentifier) {
                case 'moda':
                    setCatalogueEntries(
                        (await import('../../../hardcodedProductData/moda/catalogueEntries.json'))
                            .default,
                    );
                    break;
                case 'article':
                    setCatalogueEntries(
                        (
                            await import(
                                '../../../hardcodedProductData/article/catalogueEntries.json'
                            )
                        ).default,
                    );
                    break;
                default:
                    dispatch(
                        Logging.logError('no catalogue entries for tenant found', {
                            tenantIdentifier,
                        }),
                    );
                    return;
            }
        };

        setter();
    }, [tenantIdentifier]);

    return catalogueEntries;
};
